import { fromJS } from 'immutable';


const commonLanguages = fromJS({
    
    fr: () => new Promise(resolve => require.ensure(
        ['react-intl/locale-data/fr.js'], require => resolve(require('react-intl/locale-data/fr.js'))
    )),
    en: () => new Promise(resolve => require.ensure(
        ['react-intl/locale-data/en.js'], require => resolve(require('react-intl/locale-data/en.js'))
    )),
    es: () => new Promise(resolve => require.ensure(
        ['react-intl/locale-data/es.js'], require => resolve(require('react-intl/locale-data/es.js'))
    )),
    sv: () => new Promise(resolve => require.ensure(
        ['react-intl/locale-data/sv.js'], require => resolve(require('react-intl/locale-data/sv.js'))
    )),
    de: () => new Promise(resolve => require.ensure(
        ['react-intl/locale-data/de.js'], require => resolve(require('react-intl/locale-data/de.js'))
    ))
});


export function dynamicLocaleImport(locale) {
    
    
    
    
    const language = locale.split('-')[0];
    if (commonLanguages.has(language)) {
        return commonLanguages.get(language)();
    }
    
    
    return new Promise(resolve => require.ensure(
        ['react-intl/locale-data/'], require => resolve(require(`react-intl/locale-data/${language}.js`))
    ));
    
}
